export default function replacePlaceholders(text: string, placeholders: { [key: string]: number | string }) {
  Object.keys(placeholders).forEach((key) => {
    text = text.replace(`%${key}%`, placeholders[key].toString())
  })

  return text
}
